export enum CurrencyBagSubType {
    Coins = 5001,
}

const CurrencySubTypePrettyName = new Map<CurrencyBagSubType, string>()
CurrencySubTypePrettyName.set(CurrencyBagSubType.Coins, 'Bag of Coins')

export { CurrencySubTypePrettyName }